import store, { modulesName } from '@/store';

export const checkPermissionGuard = (to, from, next) => {
  const auth = to.meta?.authorization;
  if (auth?.requiresAuth && (auth?.permissions || []).length) {
    const hasPermission = store.getters[
      `${modulesName.userModuleName}/hasPermissions`
    ](auth.permissions);
    if (!hasPermission) {
      next('/');
    }
  }
  return next();
};
